<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: ['Account', 'Order'],
  components: {PageLoader},
  data() {
    return {
      isModalShown: true
    }
  },
  methods: {
    CloseModal() {
      this.$emit('close');
    },
    ShowWufoo() {
      var _this = this;
      var kyaaro10gkc4nz;(function(d, t) {
      var s = d.createElement(t), options = {
      'userName':'evf',
      'formHash':'kyaaro10gkc4nz',
      'autoResize':true,
      'height':'580',
      'async':true,
      'host':'wufoo.com',
      'header':'show',
      'ssl':true,
      'defaultValues':'field34='+ _this.Account.serviceFeeAmount +'&field15='+_this.Account.portalUserSalesforceId+
      '&field13='+ _this.Account.primaryContact.firstName +'&field14='+ _this.Account.primaryContact.lastName +
      '&field8='+ _this.Account.emailAddress +'&field1='+_this.Account.primaryContact.officeLocation.streetAddress+
      '&field2=&field3='+_this.Account.primaryContact.officeLocation.city+'&field4='+_this.Account.primaryContact.officeLocation.state+
      '&field5='+_this.Account.primaryContact.officeLocation.zip+'&field6=United%20States&field17=' + _this.Order.orderId};
      s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js';
      s.onload = s.onreadystatechange = function() {
      var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return;
      try { kyaaro10gkc4nz = new WufooForm();kyaaro10gkc4nz.initialize(options);kyaaro10gkc4nz.display(); } catch (e) {}};
      var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
      })(document, 'script');
      this.isWufooLoading = false;
    }
  },
  created() {
    this.isWufooLoading = true;
    this.ShowWufoo();
  },
};
</script>


// WEBPACK FOOTER //
// ServicePayment.vue?051131e7